import {
  createPlugin,
  createApiFactory,
  createComponentExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { mlflowApiRef, MlflowApiClient } from './api';
import { rootRouteRef } from './routes';

export const mlflowPlugin = createPlugin({
  id: 'mlflow',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: mlflowApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new MlflowApiClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/**
 * Model versions, aliases and metrics for a catalog entity.
 * Render it on the overview tab of ml-model components.
 */
export const EntityMlflowModelCard = mlflowPlugin.provide(
  createComponentExtension({
    name: 'EntityMlflowModelCard',
    component: {
      lazy: () =>
        import('./components/EntityMlflowModelCard').then(m => m.EntityMlflowModelCard),
    },
  }),
);
